'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _intersperse = require('linksoft/utils/intersperse');

var _intersperse2 = _interopRequireDefault(_intersperse);

var _CatalogTotalRow = require('../step1/CatalogTotalRow');

var _CatalogTotalRow2 = _interopRequireDefault(_CatalogTotalRow);

var _StepBase = require('../StepBase');

var _StepBase2 = _interopRequireDefault(_StepBase);

var _InvoicingAddress = require('../step3/InvoicingAddress');

var _InvoicingAddress2 = _interopRequireDefault(_InvoicingAddress);

var _DeliveryAddress = require('./DeliveryAddress');

var _DeliveryAddress2 = _interopRequireDefault(_DeliveryAddress);

var _OrderConfirmation = require('./OrderConfirmation');

var _OrderConfirmation2 = _interopRequireDefault(_OrderConfirmation);

var _linksoftAlbatros = require('linksoft-albatros');

var _SummaryBox = require('../step3/SummaryBox');

var _SummaryBox2 = _interopRequireDefault(_SummaryBox);

var _actions = require('../../../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _GiftItem = require('../GiftItem');

var _GiftItem2 = _interopRequireDefault(_GiftItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');
var ResxMsg = (0, _localize2.default)('Messages', 'App');

function mapStateToProps(state) {
    return {
        items: state.cart.items,
        coupon: state.cart.coupon,
        voucher: state.cart.voucher,
        freeProducts: state.cart.freeProducts,
        selectedFreeProducts: state.cart.selectedFreeProducts,
        totalProductsPrice: state.cart.totalProductsPrice,
        totalPrice: state.cart.totalPrice,
        contact: state.customer.contact,
        deliveryType: state.cart.deliveryTypes.find(function (x) {
            return x.id === state.cart.deliveryTypeId;
        }),
        paymentType: state.cart.paymentTypes.find(function (x) {
            return x.id === state.cart.paymentTypeId;
        }),
        catalogs: state.cart.catalogs,
        giftItems: state.cart.giftItems || [],
        pending: state.cart.sendingOrder,
        termsUrl: state.cart.termsUrl,
        processing: !!(state.cart.processing || (0, _keys2.default)(state.cart.changes).length || (0, _keys2.default)(state.cart.changedOptions).length || state.cart.settingCoupon),
        roundingPrecision: state.cart.roundingPrecision,
        paymentTypeId: state.cart.paymentTypeId
    };
}

var mapDispatchToProps = {
    sendOrder: _actions2.default.sendOrder
};

var SummaryStep = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_CartDetailStepBase) {
    (0, _inherits3.default)(SummaryStep, _CartDetailStepBase);

    function SummaryStep(props) {
        (0, _classCallCheck3.default)(this, SummaryStep);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SummaryStep.__proto__ || (0, _getPrototypeOf2.default)(SummaryStep)).call(this, props, 4));

        _this.submitOrder = function (e) {
            e.preventDefault();
            if (_this.props.processing) return;
            _this.props.sendOrder();
        };

        return _this;
    }

    (0, _createClass3.default)(SummaryStep, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                giftItems = _props.giftItems,
                items = _props.items,
                deliveryType = _props.deliveryType,
                paymentType = _props.paymentType,
                coupon = _props.coupon,
                totalProductsPrice = _props.totalProductsPrice,
                freeProducts = _props.freeProducts,
                selectedFreeProducts = _props.selectedFreeProducts,
                pending = _props.pending,
                processing = _props.processing,
                termsUrl = _props.termsUrl,
                catalogs = _props.catalogs,
                roundingPrecision = _props.roundingPrecision,
                paymentTypeId = _props.paymentTypeId;
            var finalPrice = totalProductsPrice.finalPrice,
                finalPriceWithoutVat = totalProductsPrice.finalPriceWithoutVat;


            if (roundingPrecision && roundingPrecision[paymentTypeId]) {
                var precision = roundingPrecision[paymentTypeId];
                finalPrice = Math.round(finalPrice / precision) * precision;
                finalPriceWithoutVat = Math.round(finalPriceWithoutVat / precision) * precision;
            }

            var btnClass = 'btn btn--lg btn--green';
            if (pending) {
                btnClass += ' btn--pending';
            }
            if (processing) {
                btnClass += ' btn--inactive';
            }

            var totalAmount = items.reduce(function (a, item) {
                return a + item.amount;
            }, 0);

            var freeProductAmounts = selectedFreeProducts.reduce(function (selected, item) {
                var existingItem = selected.find(function (p) {
                    return p.productId === item.productId;
                });
                if (existingItem) {
                    existingItem.amount += item.amount;
                } else {
                    selected.push({ productId: item.productId, amount: item.amount });
                }
                totalAmount += item.amount;
                return selected;
            }, []);

            var allProducts = freeProducts.reduce(function (ar, campaign) {
                return ar.concat(campaign.freeProducts);
            }, []);

            var selectedFreeProductsWithAmounts = freeProductAmounts.reduce(function (result, item) {
                var product = allProducts.find(function (x) {
                    return x.productId === item.productId;
                });
                result.push({ amount: item.amount, product: product });
                return result;
            }, []);

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: '' },
                    _react2.default.createElement(
                        'h1',
                        { className: 'mt-2' },
                        Resx.App.CartSummary
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'step__inner' },
                    _react2.default.createElement(
                        'div',
                        { className: 'cart__wrap' },
                        _react2.default.createElement(
                            'div',
                            { className: 'table-responsive' },
                            _react2.default.createElement(
                                'table',
                                { className: 'table__sumary cart__table' },
                                _react2.default.createElement(
                                    'thead',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            _react2.default.createElement(
                                                'span',
                                                null,
                                                Resx.App.ProductName
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            null,
                                            _react2.default.createElement(
                                                'span',
                                                null,
                                                Resx.App.Author
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'text-center' },
                                            _react2.default.createElement(
                                                'span',
                                                null,
                                                Resx.Common.Amount
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'text-right' },
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'nowrap' },
                                                Resx.App.YourPrice
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'text-right' },
                                            _react2.default.createElement(
                                                'span',
                                                null,
                                                Resx.App.TotalPriceWithoutVat
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'th',
                                            { className: 'text-right' },
                                            _react2.default.createElement(
                                                'span',
                                                null,
                                                Resx.App.TotalPriceWithVat
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    giftItems.length > 0 && [_react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            { colSpan: '6' },
                                            _react2.default.createElement(
                                                'h2',
                                                { className: 'cart-items__title' },
                                                Resx.App.Gifts
                                            )
                                        )
                                    ), giftItems.map(function (item) {
                                        return _react2.default.createElement(_GiftItem2.default, (0, _extends3.default)({}, item, { key: item.giftId,
                                            summary: true }));
                                    })],
                                    catalogs.filter(function (c) {
                                        return c.items.length > 0;
                                    }).map(function (c) {
                                        return [_react2.default.createElement(
                                            'tr',
                                            null,
                                            _react2.default.createElement(
                                                'td',
                                                { colSpan: '6' },
                                                _react2.default.createElement(
                                                    'h2',
                                                    null,
                                                    c.name
                                                )
                                            )
                                        ), c.items.sort(function (a, b) {
                                            return a.name.localeCompare(b.name);
                                        }).map(function (item) {
                                            return _react2.default.createElement(
                                                'tr',
                                                { key: item.id },
                                                _react2.default.createElement(
                                                    'td',
                                                    { className: 'w-40' },
                                                    _react2.default.createElement(
                                                        'strong',
                                                        null,
                                                        item.name
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    null,
                                                    (0, _intersperse2.default)((item.authors || []).map(function (author) {
                                                        return _react2.default.createElement(
                                                            'span',
                                                            {
                                                                key: author.id },
                                                            author.name
                                                        );
                                                    }), ', ')
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    { className: 'text-center' },
                                                    item.amount
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    { className: 'text-right nowrap' },
                                                    (0, _linksoftAlbatros.formatPrice)(item.price.unitPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    { className: 'text-right nowrap' },
                                                    (0, _linksoftAlbatros.formatPrice)(item.price.totalPrice.finalPriceWithoutVat, _linksoftAlbatros.PriceType.CartTotalPrice)
                                                ),
                                                _react2.default.createElement(
                                                    'td',
                                                    { className: 'text-right nowrap' },
                                                    (0, _linksoftAlbatros.formatPrice)(item.price.totalPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                                                )
                                            );
                                        }), _react2.default.createElement(_CatalogTotalRow2.default, { catalog: c, key: c.id, includeWoVatPrice: true })];
                                    }),
                                    selectedFreeProductsWithAmounts.length > 0 && _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            { colSpan: '6' },
                                            _react2.default.createElement(
                                                'h2',
                                                null,
                                                Resx.App.FreeProducts
                                            )
                                        )
                                    ),
                                    selectedFreeProductsWithAmounts.map(function (item) {
                                        return _react2.default.createElement(
                                            'tr',
                                            { key: item.product.productId },
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                _react2.default.createElement(
                                                    'strong',
                                                    null,
                                                    item.product.productName
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                null,
                                                (0, _intersperse2.default)((item.product.authors || []).map(function (author) {
                                                    return _react2.default.createElement(
                                                        'span',
                                                        {
                                                            key: author.id },
                                                        author.name
                                                    );
                                                }), ', ')
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'text-center' },
                                                item.amount
                                            ),
                                            _react2.default.createElement(
                                                'td',
                                                { className: 'text-center nowrap green', colSpan: 3 },
                                                Resx.App.FreeOfCharge
                                            )
                                        );
                                    })
                                ),
                                _react2.default.createElement(
                                    'tfoot',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement('td', null),
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'text-right red' },
                                            _react2.default.createElement(
                                                'strong',
                                                null,
                                                Resx.App.Total
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'text-center red' },
                                            _react2.default.createElement(
                                                'strong',
                                                null,
                                                totalAmount
                                            )
                                        ),
                                        _react2.default.createElement('td', null),
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'text-right nowrap red' },
                                            _react2.default.createElement(
                                                'strong',
                                                null,
                                                (0, _linksoftAlbatros.formatPrice)(finalPriceWithoutVat, _linksoftAlbatros.PriceType.CartTotalPrice)
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'text-right nowrap red' },
                                            _react2.default.createElement(
                                                'strong',
                                                null,
                                                (0, _linksoftAlbatros.formatPrice)(finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            coupon && _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement('hr', null),
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        Resx.App.Coupon
                                    ),
                                    ': ',
                                    coupon.code,
                                    ' ',
                                    coupon.name
                                )
                            )
                        ),
                        _react2.default.createElement('hr', null),
                        _react2.default.createElement(_InvoicingAddress2.default, null),
                        _react2.default.createElement('hr', null),
                        _react2.default.createElement(_DeliveryAddress2.default, null),
                        _react2.default.createElement('hr', null),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            deliveryType && _react2.default.createElement(
                                'div',
                                { className: 'col-sm-6' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'd-flex align-items-center' },
                                    _react2.default.createElement(
                                        'h3',
                                        { className: 'mt-0 mb-0' },
                                        Resx.App.DeliveryType,
                                        ':'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        {
                                            className: 'pl-3' },
                                        deliveryType.name,
                                        ' (',
                                        (0, _linksoftAlbatros.formatPrice)(deliveryType.deliveryPrice, _linksoftAlbatros.PriceType.CartTotalPrice),
                                        ')'
                                    )
                                )
                            ),
                            paymentType && _react2.default.createElement(
                                'div',
                                { className: 'col-sm-6' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'd-flex align-items-center' },
                                    _react2.default.createElement(
                                        'h3',
                                        { className: 'mt-0 mb-0' },
                                        Resx.App.PaymentType,
                                        ':'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        {
                                            className: 'pl-3' },
                                        paymentType.name,
                                        ' (',
                                        (0, _linksoftAlbatros.formatPrice)(paymentType.paymentPrice, _linksoftAlbatros.PriceType.CartTotalPrice),
                                        ')'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement('hr', null),
                        _react2.default.createElement(_OrderConfirmation2.default, null)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'cart__aside' },
                        _react2.default.createElement(
                            'div',
                            { className: 'cart-summary' },
                            _react2.default.createElement(_SummaryBox2.default, { cart: this.props.cart }),
                            _react2.default.createElement(
                                'div',
                                { className: 'cart-summary__submit text-center' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'above__submit mb-3' },
                                    _react2.default.createElement('i', { dangerouslySetInnerHTML: { __html: ResxMsg.Messages.CartConfirmationMessage.replace('{0}', termsUrl) } })
                                ),
                                _react2.default.createElement(
                                    'button',
                                    { className: btnClass + " scart-summary__submit-order",
                                        onClick: this.submitOrder },
                                    Resx.App.BindOrderKmc
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'mt-5 text-center' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn--sm',
                                    onClick: function onClick() {
                                        return _this2.prevStep();
                                    } },
                                '< ',
                                Resx.Common.Back
                            )
                        )
                    )
                )
            );
        }
    }]);
    return SummaryStep;
}(_StepBase2.default), _class2.propTypes = {
    items: _propTypes2.default.array.isRequired,
    sendOrder: _propTypes2.default.func,
    pending: _propTypes2.default.bool,
    processing: _propTypes2.default.bool,
    giftItems: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    catalogs: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
}, _temp)) || _class);
exports.default = SummaryStep;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step4/Step.js
// module id = 1145
// module chunks = 0